import { css } from "emotion";

import { colors, fonts, icons } from "@cobliteam/base-components/src/styles";

export const controlButton = css`
  min-height: 30px;
  min-width: 30px;
  box-shadow: 0 0 10px 0 ${colors.custom.gray20};

  & > svg {
    margin: auto;
    font-size: $icons.size.medium;
  }
`;

export const controlButtonText = css`
  font-weight: ${fonts.weight.bold};
  margin: auto;

  &:not(:first-child) {
    margin-left: 10px;
  }
`;
